import { _ as _asyncToGenerator, r as regenerator } from '../../index-6bb2031f.js';
import { _ as _toConsumableArray } from '../../toConsumableArray-2a2700d9.js';
import { getLayerManipulations } from '../../external/index.js';
import '../../typeof-92b42de1.js';
import '../../unsupportedIterableToArray-577176bf.js';

var isFontAlreadyLoaded = function isFontAlreadyLoaded(fontFamily) {
  var isFontLoaded = _toConsumableArray(document.fonts.values()).some(function (_ref) {
    var family = _ref.family,
        status = _ref.status;
    return family === fontFamily && ['loaded', 'loading'].includes(status);
  });

  return isFontLoaded;
};

var loadFont = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(fontName, path) {
    var isFontLoaded, junctionFont, loadedFace;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            isFontLoaded = !document && isFontAlreadyLoaded(fontName);

            if (!isFontLoaded) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            _context.next = 5;
            return new FontFace(fontName, "url(".concat(path, ")"));

          case 5:
            junctionFont = _context.sent;

            if (!(!junctionFont.family || !path)) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return");

          case 8:
            _context.prev = 8;
            _context.next = 11;
            return junctionFont.load();

          case 11:
            loadedFace = _context.sent;
            // loaded_face holds the loaded FontFace
            document.fonts.add(loadedFace);
            _context.next = 15;
            return document.fonts.ready;

          case 15:
            return _context.abrupt("return", loadedFace);

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](8);
            getLayerManipulations().logger(_context.t0, 'error');

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[8, 18]]);
  }));

  return function loadFont(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();

export { loadFont as default };
